module.exports = __webpack_public_path__ + "static/media/soccer.c247765c.svg";